"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("@fortawesome/fontawesome-free/css/all.css");

require("@fortawesome/fontawesome-free/css/v4-shims.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconStyled = _styledComponents["default"].i.attrs(function () {
  return {
    id: "best-icon"
  };
}).withConfig({
  displayName: "Icon__IconStyled",
  componentId: "sc-2ak5gb-0"
})(["color:", ";&:hover{color:", ";cursor:pointer;}"], function (props) {
  return props.styles.color;
}, function (props) {
  return props.styles.hoverColor;
});

var IconHolder = _styledComponents["default"].div.withConfig({
  displayName: "Icon__IconHolder",
  componentId: "sc-2ak5gb-1"
})(["font-size:", ";display:inline-block;"], function (props) {
  return props.styles.size;
});

var Icon = function Icon(_ref) {
  var iconName = _ref.iconName,
      iconCategory = _ref.iconCategory,
      className = _ref.className,
      styles = _ref.styles,
      rest = _objectWithoutProperties(_ref, ["iconName", "iconCategory", "className", "styles"]);

  var Theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var DefaultStyle = {
    color: Theme.icon["color"],
    size: Theme.icon["size"],
    hoverColor: Theme.icon["hover"]
  };
  var classList = iconCategory + " " + iconName + " " + className;

  var CompStyles = _objectSpread({}, DefaultStyle, {}, styles);

  return _react["default"].createElement(IconHolder, {
    styles: CompStyles
  }, _react["default"].createElement(IconStyled, _extends({
    className: classList,
    styles: CompStyles
  }, rest)));
};

Icon.propTypes = {
  /** Name of the icon to provide - expects font awesome name without fa */
  iconName: _propTypes["default"].string.isRequired,

  /** The icon category for font awesome - defaults to fas*/
  iconCategory: _propTypes["default"].string.isRequired,

  /** additional classes to add to the icon */
  className: _propTypes["default"].string,

  /** Custom styles object */
  styles: _propTypes["default"].shape({
    hoverColor: _propTypes["default"].string,
    size: _propTypes["default"].string,
    color: _propTypes["default"].string
  })
};
Icon.defaultProps = {
  className: "",
  iconCategory: "fas",
  styles: {}
};
var _default = Icon;
exports["default"] = _default;